import styled, { keyframes } from "styled-components";

export const subtitleFadeIn = keyframes`
  0% {
    opacity: 0;
  }
  35% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
 `;

export const FakeInputContainer = styled.div`
    .ListItemWebsite {
        height: 34px;
        margin-bottom: 2px;
    }
`;
